import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { logout as logoutAction } from '../../logic/store/authentication/actions';

// Components
import ExpirationWindow from './ExpirationWindow';

export const SessionExpirationComponent = (props) => {
  const [isApplicationTabHidden, changeApplicationVisability] = useState(false);

  const getPageVisabilityParams = () => {
    let hidden;
    let visibilityChange;

    if (typeof document.hidden !== 'undefined') {
      hidden = 'hidden';
      visibilityChange = 'visibilitychange';
    } else if (typeof document.msHidden !== 'undefined') {
      hidden = 'msHidden';
      visibilityChange = 'msvisibilitychange';
    } else if (typeof document.webkitHidden !== 'undefined') {
      hidden = 'webkitHidden';
      visibilityChange = 'webkitvisibilitychange';
    }

    const handleVisibilityChange = () => changeApplicationVisability(document[hidden]);

    return { handleVisibilityChange, hidden, visibilityChange };
  };

  const executeEvent = (hidden, event) => {
    if (typeof document.addEventListener !== 'undefined' || hidden !== undefined) {
      event();
    }
  };

  const addPageVisibilityEvent = ({ handleVisibilityChange, hidden, visibilityChange }) => {
    executeEvent(hidden, () =>
      document.addEventListener(visibilityChange, handleVisibilityChange, false)
    );
  };

  const removePageVisibilityEvent = ({ handleVisibilityChange, hidden, visibilityChange }) => {
    executeEvent(hidden, () =>
      document.removeEventListener(visibilityChange, handleVisibilityChange, false)
    );
  };

  useEffect(() => {
    const pageVisabilityParams = getPageVisabilityParams();
    addPageVisibilityEvent(pageVisabilityParams);

    return () => removePageVisibilityEvent(pageVisabilityParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ExpirationWindow isApplicationTabHidden={isApplicationTabHidden} {...props} />;
};

SessionExpirationComponent.propTypes = {
  logout: PropTypes.func
};

SessionExpirationComponent.defaultProps = {
  logout() {}
};

export default connect(null, { logout: logoutAction })(SessionExpirationComponent);
